import React from "react";
import { connect } from "react-redux";
import { fetchDocUser } from "../../reducers/doc_users/actions";
import { UD_EDITOR, UD_AUTHOR } from "../../settings";
import { Content, Container } from "../../pages/Template";
import AddUserLink from "./AddUserLink";
import List from "./List";
import { isMobile, setWindowTitle } from "../../helpers";
import { AppState } from "../../store";

const mapStateToProps = (
    { doc_users, user }: AppState,
    {
        match: {
            params: { doc_id },
        },
    }: { match: { params: { doc_id: string } } }
) => ({
    doc_id: parseInt(doc_id),
    // @ts-ignore
    user_id: user.get("id"),
    // @ts-ignore
    loggedInDocUser: doc_users.get(`${doc_id}-${user.get("id")}`) as Map<
        string,
        string
    >,
});
const mapDispatch = { fetchDocUser };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatch;

type Props = StateProps & DispatchProps;
type State = {
    status: string;
};

class DocUsersPage extends React.Component<Props, State> {
    static paths = ["/app/users/:doc_id"];
    static requiresAuth = true;

    constructor(props: Props) {
        super(props);
        this.state = {
            status: "",
        };
    }

    componentDidMount() {
        const { doc_id, user_id } = this.props;
        this.props.fetchDocUser({ doc_id, user_id });

        setWindowTitle("دستاویز سے متعلق صارف");
    }

    componentWillReceiveProps(nextProps: Props) {
        const { loggedInDocUser } = nextProps;
        if (loggedInDocUser) {
            this.setState({
                status: loggedInDocUser.get("status")!,
            });
        }
    }

    render() {
        const { status } = this.state;
        const { doc_id } = this.props;

        return (
            <Content isLandingPage={isMobile()}>
                <Container width="800px">
                    {[UD_EDITOR, UD_AUTHOR].includes(status) && (
                        <AddUserLink doc_id={doc_id} />
                    )}
                    <List doc_id={doc_id} status={status} />
                </Container>
            </Content>
        );
    }
}

export default connect(mapStateToProps, mapDispatch)(DocUsersPage);
